import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navbar.module.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
  }, [menuOpen]);

  const close = () => setMenuOpen(false);

  return (
    <>
      <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`}>
        <Link to="/" className={styles.logo}>
          <span className={styles.logoX}>X</span> HAUS
        </Link>

        <ul className={styles.links}>
          <li><a href="/#artists">Artistler</a></li>
          <li><a href="/#gallery">Galeri</a></li>
          <li><a href="/#about">Hakkımızda</a></li>
          <li><a href="/#contact">İletişim</a></li>
        </ul>

        <div className={styles.navRight}>
          <a href="/#contact" className={styles.bookBtn}>Randevu Al</a>
          <button
            className={`${styles.hamburger} ${menuOpen ? styles.hamOpen : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Menü"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileOpen : ''}`}>
        <a href="/#artists" onClick={close}>Artistler</a>
        <a href="/#gallery" onClick={close}>Galeri</a>
        <a href="/#about" onClick={close}>Hakkımızda</a>
        <a href="/#contact" onClick={close}>İletişim</a>
        <a href="/#contact" className="btn-primary" onClick={close}>Randevu Al</a>
      </div>
    </>
  );
}
